import React from "react";

interface Props {
  width: number;
  height: number;
}

export const PlayVideoIcon = ({ width, height }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28.5" cy="28.5" r="28.5" fill="white" />
      <path d="M41 29L21.5 40.2583L21.5 17.7417L41 29Z" fill="black" />
    </svg>
  );
};
